/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/10/22, 8:30 PM
 *
 */

import MemberProfileHeader from 'features/members/components/others/MemberProfileHeader/MemberProfileHeader';

export default MemberProfileHeader;
